import React from "react";

export const General = () => {
  return (
    <span className="terminos-condiciones">
      <p className="text-center">
        <strong>
          <u>TÉRMINOS Y CONDICIONES DE USO</u>
        </strong>
      </p>
      <p>
        Bienvenido. Este Sitio Web es una herramienta de EDENRED ARGENTINA S.A.
        a disposición de los establecimientos integrantes de su Red de
        comercios, con el objeto de que estos realicen las gestiones de
        correspondientes a los reembolsos por las transacciones realizadas,
        adelantos de reembolso y acceso a información sobre resultados de
        negocio.
      </p>
      <p>
        El uso de este Sitio está sujeto a los presentes Términos y condiciones.
        En la Página Principal de este Sitio Web aparece en forma ostensible un
        vínculo –link- con estos Términos, los cuales estarán disponibles
        permanentemente para su revisión, siendo su lectura y aceptación de
        carácter obligatorio, así mismo se enviará el documento vía mail.
      </p>
      <p>
        EL USO DE ESTE SITIO IMPLICA QUE ACUERDA SOMETERSE A TODOS Y CADA UNO DE
        LOS SIGUIENTES TÉRMINOS Y COMPRENSIÓN DE LOS MISMOS.
      </p>
      <p>
        EDENRED ARGENTINA podrá modificar estos Términos (de manera parcial o
        total) en cualquier momento, poniendo a disposición los nuevos Términos
        en este Sitio. El hecho de que continúe utilizando este Sitio implica
        que Ud. presta su consentimiento a cualquiera de dichas modificaciones
        y, por lo tanto, sugerimos visitar periódicamente esta página a fin de
        comprobar cuáles son los Términos en vigencia en ese momento.
      </p>
      <p>
        En el caso de que cualquier disposición de estos Términos fuera
        declarada inválida, ilegal o inexigible por un tribunal, se considerará
        que dicha disposición puede excluirse de estos Términos, permaneciendo
        las restantes disposiciones en plena vigencia y efecto. El hecho de que
        EDENRED ARGENTINA no ejerciera o hiciera valer algún derecho o
        disposición de estos Términos no constituirá una renuncia a dicho
        derecho o disposición.
      </p>
      <p>
        <u>Algunas Definiciones:</u>
      </p>
      <p>
        A continuación, se establecen las definiciones que explican algunas de
        las acepciones y alcances sobre el vocabulario empleado en estos
        Términos:
      </p>
      <p>
        Las palabras "usted", “Ud.” y "su" hacen referencia a el/los
        establecimientos comerciales de la Red de Edenred Argentina, pudiendo
        ser estos personas humanas o jurídicas, conforme la legislación
        aplicable, y sus agentes, apoderados o representantes.
      </p>
      <ul>
        <li>
          <p>"EDENRED ARGENTINA " hace referencia a EDENRED ARGENTINA S.A.</p>
        </li>
        <li>
          <p>
            "Nosotros", "nuestro" y demás pronombres personales de primera
            persona hacen referencia a EDENRED ARGENTINA.
          </p>
        </li>
        <li>
          <p>
            "Sitio" significa la página principal y todas las páginas
            relacionadas a las que pueda accederse a través de la página
            principal en forma directa o mediante vínculos adicionales, pero no
            incluye sitios web de terceros que no sean mantenidos o patrocinados
            por EDENRED ARGENTINA.
          </p>
        </li>
        <li>
          <p>
            “Material” y “Materiales” hacen referencia a todo dato, información,
            comprobante, factura, nota de crédito, etc. que Ud. cargue en el
            Sitio.
          </p>
        </li>
        <li>
          <p>
            Acreditación en cuenta: es la modalidad de depósito normal y
            habitual por la que el comercio percibe los montos acreditados.
          </p>
        </li>
        <li>
          <p>
            Consumo promedio por transacción: es la resultante del cálculo entre
            volumen consumido y Cantidad de transacciones.
          </p>
        </li>
        <li>
          <p>
            Días ganados: días de adelanto generado sobre Reembolsos programados
            que generó un comercio o CUIT.
          </p>
        </li>
        <li>
          <p>
            Empresarial: es la modalidad de depósito mediante tarjeta Edenred
            (red MasterCard) por la que el comercio puede optar percibir los
            montos a acreditar.
          </p>
        </li>
        <li>
          <p>
            Estado: Es la categoría interna de Edenred que indica la situación
            de la presentación.
          </p>
        </li>
        <li>
          <p>
            Gastos Administrativos: son los gastos correspondientes a la
            ejecución de operatorias que puede implicar el adelanto de un
            reembolso, conforme el método o forma de acreditación seleccionada
            por el comercio.
          </p>
        </li>
        <li>
          <p>
            Monto a acreditar: es el monto neto a percibir por el comercio,
            resultante de la aplicación de la totalidad de descuentos
            correspondientes a los reembolsos.
          </p>
        </li>
        <li>
          <p>
            Pago Express: es la posibilidad de adelantar la fecha de
            acreditación de los reembolsos programados, pudiendo el comercio
            seleccionar los montos y modalidad de acreditación, según lo
            estipulado en los términos y condiciones del particular.
          </p>
        </li>
        <li>
          <p>
            Presentación: agrupación de transacciones presentadas por el
            comercio (de manera automática o manual por el comercio, según la
            tipología de solución) para la generación de reembolsos a los
            Comercios de la red.
          </p>
        </li>
        <li>
          <p>
            Producto: es la tipología de solución o servicio al que hace
            referencia una Presentación.
          </p>
        </li>
        <li>
          <p>
            Reembolsados: es la suma de liquidaciones netas percibidas por los
            comercios en un plazo de tiempo determinado.
          </p>
        </li>
        <li>
          <p>
            Reembolsos en proceso: son los reembolsos cuya fecha de acreditación
            se encuentra prevista dentro de las próximas 48hs en la que se
            realiza la consulta, cuya fecha de acreditación no es susceptible de
            ser modificada.
          </p>
        </li>
        <li>
          <p>
            Reembolsos programados: son aquellos reembolsos cuya fecha de
            acreditación está prevista a partir de las 72hs (en adelante) a la
            generación de la consulta de reembolsos, cuya fecha de acreditación
            es susceptible de ser adelantada mediante la modalidad de “Reembolso
            Express” conforme aceptación de términos y condiciones del
            particular.
          </p>
        </li>
        <li>
          <p>
            Reembolsos: suma de liquidaciones presentadas para ser percibidas
            por el/los comercio/s de la Red. Cada reembolso cuenta con una fecha
            estipulada para su acreditación, conforme condiciones comerciales
            por solución y proceso correspondiente.
          </p>
        </li>
        <li>
          <p>TNM: tasa nominal mensual.</p>
        </li>
        <li>
          <p>
            Transacciones: suma de operaciones individuales realizadas por los
            usuarios de las soluciones de Edenred que componen una liquidación.
          </p>
        </li>
        <li>
          <p>
            Volumen Consumido: es la sumatoria nominal de transacciones
            unitarias generadas en un comercio o CUIT, para un periodo de tiempo
            determinado.
          </p>
        </li>
      </ul>
      <p>
        <u>Accesibilidad:</u>
      </p>
      <p>
        Para acceder al presente Sitio EDENRED ARGENTINA le proporcionó a Ud.,
        en su carácter de establecimiento perteneciente a la Red, un usuario y
        contraseña. Por lo dicho sí Ud. no pertenece la red de establecimientos
        de EDENRED ARGENTINA absténgase de utilizar el presente Sitio.
      </p>
      <p>Uso de Material Protegido por Derechos de Autor en este Sitio</p>
      <p>
        Los derechos de autor sobre todos los materiales provistos incluyendo,
        entre otros las marcas y logos, en este Sitio por EDENRED ARGENTINA son
        de titularidad de EDENRED ARGENTINA o del creador original del material.
        EDENRED ARGENTINA le otorga una licencia limitada, no exclusiva e
        intransferible, para usar y mostrar –de buena fe- los materiales de este
        Sitio solamente con la finalidad de su interacción con el mismo. La
        licencia incluye el derecho a imprimir dicho material, pero sólo con los
        fines mencionados. A menos que se establezca lo contrario, usted no
        tiene derecho alguno a copiar, mostrar, reproducir, descargar,
        distribuir, modificar, editar, alterar o incrementar los materiales en
        forma alguna, incluyendo, sin que implique limitación, en forma
        electrónica, mecánica, de fotocopiado, grabación o de otra manera, sin
        la previa autorización escrita de EDENRED ARGENTINA o del titular de los
        derechos de autor. Esta licencia se extingue automáticamente y sin
        notificación previa si usted infringe cualquiera de estos Términos. Una
        vez extinguida, usted debe destruir cualquiera de los materiales
        descargados o impresos que hubieran sido obtenidos de este Sitio.
      </p>
      <p>
        <u>Información Confidencial o de Propiedad de EDENRED ARGENTINA:</u>
      </p>
      <p>
        EDENRED ARGENTINA posee políticas y procedimientos diseñados para
        prevenir, en su sitio de internet, la revelación de información que
        EDENRED ARGENTINA considera confidencial o secretos comerciales de su
        propiedad. Sin embargo, si en cualquier momento Ud. obtiene de este
        sitio de internet, información confidencial o secretos comerciales de
        propiedad de EDENRED ARGENTINA que pudieran ser revelados
        inadvertidamente por EDENRED ARGENTINA, Ud. acuerda actuar de buena fe
        en reconocer y respetar la confidencialidad de esa información y Ud.
        acuerda no hacer uso de o revelar a ningún tercero, cualquier
        información o secreto comercial que pudiera obtener de este sitio de
        internet, y a destruir cualquier copia de esa información que pudiera
        tener en su posesión, en cualquier soporte en que se encuentre la misma.
      </p>
      <p>
        <u>Nombres de Usuarios y Contraseñas:</u>
      </p>
      <p>
        Para ingresar y utilizar el presente Sitio Ud. ha recibido, de EDENRED
        ARGENTINA, un nombre de Usuario y contraseña, entonces:
      </p>
      <ul>
        <li>
          <p>
            Usted acuerda utilizar el Sitio exclusivamente con fines legítimos.
          </p>
        </li>
        <li>
          <p>
            Al ingresar con su nombre de Usuario, acuerda emplear únicamente
            información exacta y verdadera sobre usted y no imitará a ninguna
            otra persona ni asumirá una identidad falsa.
          </p>
        </li>
        <li>
          <p>
            Usted acuerda notificarnos de inmediato sobre cualquier uso no
            autorizado de su Contraseña, Nombre de Usuario o del Sitio, o
            cualquier otra violación de seguridad, para ello envíe un mail a la
            siguiente casilla:{" "}
            <a href="mailto:mde_comunicacion-AR@edenred.com">
              mde_comunicacion-AR@edenred.com
            </a>{" "}
            o contáctese telefónicamente a: 11 4909-1234 opción MDE-.
          </p>
        </li>
        <li>
          <p>
            Usted acuerda no compartir su Nombre de Usuario o Contraseña con
            ninguna otra persona.
          </p>
        </li>
        <li>
          <p>
            Usted acuerda asumir plena responsabilidad por todos los riesgos
            emergentes del uso del Sitio por parte de usted o de cualquier otra
            persona que utilice su Nombre de Usuario o Contraseña.
          </p>
        </li>
      </ul>
      <p>
        EDENRED ARGENTINA se reserva el derecho, en cualquier momento y a su
        exclusivo criterio, de modificar o suspender el Sitio, modificar o
        suspender cualquier información u otro contenido del Sitio o revocar su
        Contraseña y Nombre de Usuario y su uso del Sitio, con o sin motivo.{" "}
      </p>
      <p>
        <u>Operaciones:</u>
      </p>
      <p>
        Ud., con su Nombre de Usuario y Contraseña, deberá ingresar al Sitio y
        seleccionar aquel/aquellos lote/s que desea presentar, completando la
        información solicitada en el Sitio y adjuntando la imagen del
        comprobante debidamente emitido (factura, nota de crédito y/o ticket
        factura) que corresponda a dicho/s lote/s. Cumplimentado esto, EDENRED
        ARGENTINA iniciará el proceso de validación de la información y
        documentación por Ud. presentada. Finalizado este proceso, podrá
        resultar la aprobación o rechazo de la información y documentación
        presentada. En caso de rechazo, Ud. deberá presentar nuevamente la
        información y documentación correctas para dar respuesta al motivo del
        rechazo. Realizado ello, EDENRED ARGENTINA iniciará el proceso de
        validación correspondiente conforme lo explicado en el presente párrafo.
      </p>
      <p>
        Aprobada/s la/s presentación/presentaciones, Ud. Tendrá la obligación de
        remitir, vía postal y la primer semana de cada mes, a EDENRED ARGENTINA
        la documentación en original cuya/s imagen/imágenes haya/n sido
        presentada/s. Dicha documentación deberá ser remitida en sobre/s
        rotulado/s conforme instrucciones de EDENRED ARGENTINA. En tal sentido,
        en el/los sobre/s se incluirá, además de la documentación mencionada,
        copia del comprobante de operación que emite el Sitio al finalizar cada
        presentación. Le recordamos que la falta de cumplimiento de este
        requisito -envío vía postal y durante la primer semana de cada mes,
        conforme lo expuesto en este párrafo- imposibilitará que las
        subsiguientes presentaciones prosperen.
      </p>
      <p>
        <u>Marcas:</u>
      </p>
      <p>
        Las marcas, marcas de servicios y logotipos (las "Marcas") que se usan y
        muestran en este Sitio son Marcas registradas de EDENRED. A menos que se
        establezca lo contrario en el Sitio, no se interpretará que nada en este
        Sitio otorga una licencia o derecho a usar cualquier Marca que se
        muestre en el Sitio, sin la aprobación escrita del titular de la Marca.
        Salvo que se indique expresamente en el Sitio, el nombre EDENRED
        ARGENTINA o su logo no podrá ser usado en forma alguna, incluyendo
        avisos o publicidad, sin la previa autorización escrita de EDENRED
        ARGENTINA.
      </p>
      <p>
        <u>Privacidad:</u>
      </p>
      <p>
        En la medida en que este Sitio contenga Información Personal sobre
        usted, nuestro uso de dicha información se encuentra sujeto a la
        Política de Privacidad de EDENRED ARGENTINA, cuyos términos se
        encuentran incluidos en este Sitio.
      </p>
      <p>
        <u>Inexistencia de Garantías</u>
      </p>
      <p>
        EDENRED ARGENTINA NO OTORGA GARANTÍA NI EFECTÚA DECLARACIÓN ALGUNA EN
        RELACIÓN CON EL USO, VALIDEZ, EXACTITUD O CONFIABILIDAD O LOS RESULTADOS
        DEL USO DE, O DE OTRA MANERA RELACIONADOS CON, LOS MATERIALES EN ESTE
        SITIO, EL FUNCIONAMIENTO DEL SITIO O DE CUALESQUIERA SITIOS VINCULADOS A
        ESTE SITIO.
      </p>
      <p>
        <u>Limitaciones a la Responsabilidad de EDENRED ARGENTINA:</u>
      </p>
      <p>
        EDENRED ARGENTINA NO TENDRÁ RESPONSABILIDAD ALGUNA, BAJO NINGUNA
        CIRCUNSTANCIA, INCLUYENDO, SIN QUE ELLO IMPLIQUE LIMITACIÓN ALGUNA, POR
        CULPA, EN RELACION CON CUALESQUIERA DAÑOS Y PERJUICIOS DIRECTOS O
        INDIRECTOS, INCLUYENDO, SIN CARÁCTER RESTRICTIVO, LA PÉRDIDA DE DATOS O
        LUCRO CESANTE, ORIGINADOS EN EL SITIO O EN EL USO O LA IMPOSIBILIDAD DE
        USO DE LOS MATERIALES OBRANTES EN ESTE SITIO, AÚN CUANDO EDENRED
        ARGENTINA O UN REPRESENTANTE AUTORIZADO DE EDENRED ARGENTINA HAYAN SIDO
        INFORMADOS ACERCA DE LA POSIBLE OCURRENCIA DE DICHOS DAÑOS Y PERJUICIOS.
      </p>
      <p>
        EN CASO DE QUE, COMO CONSECUENCIA DE SU UTILIZACION DE ESTE SITIO, FUERA
        NECESARIO UN MANTENIMIENTO, REPARACION O CORRECCIÓN DE EQUIPOS O DATOS,
        UD. ASUMIRÁ LOS COSTOS QUE DE ELLO SE DERIVARAN.
      </p>
      <p>
        <u>Obligaciones de Indemnizar:</u>
      </p>
      <p>
        Usted acuerda defender, indemnizar y mantener indemne a EDENRED
        ARGENTINA y sus respectivos directores, funcionarios, empleados y
        agentes respecto de todos los daños y perjuicios, reclamos y gastos,
        incluyendo los honorarios de abogados, originados en el uso que usted
        hiciera de este Sitio o por el uso indebido de cualquier información
        obtenida de este Sitio o la transmisión que usted hiciera de
        información, datos, materiales o contenido del Sitio.
      </p>
      <p>
        <u>Avisos que pueden aparecer en el Sitio:</u>
      </p>
      <p>
        En caso que en este Sitio aparezca una publicidad de un producto o
        servicio brindado por otra persona que no sea EDENRED ARGENTINA, esta
        última no avala ni brinda garantía alguna respecto de dicho producto o
        servicio y no será parte ni en modo alguno supervisará ninguna operación
        llevada a cabo entre usted y terceros proveedores de productos o
        servicios. Respecto a la compra de un producto o servicio a través de
        cualquier medio o en cualquier entorno, deberá emplear su mejor criterio
        y adoptar una conducta cautelosa cuando ello fuere menester.
      </p>
      <p>
        <u>Material, datos e información ingresados en el Sitio:</u>
      </p>
      <p>
        El Sitio le permite colocar o cargar contenido en el mismo por lo que
        serán aplicables a dicho uso y son aceptados por usted en el presente
        los siguientes términos:
      </p>
      <p>
        Usted interpreta que toda la información, contenido, texto, datos,
        mensajes u otros materiales, incluidos en el Sitio o transmitidos en
        forma privada (el "Material") son de responsabilidad de la persona de
        quien proviene dicho Material. Usted será responsable de todo Material
        que coloque, transmita o que de otro modo ponga a disposición del Sitio;
        quedando sujeto el Material a la posterior validación de EDENRED
        ARGENTINA. Usted reconoce y acuerda que debe evaluar y soportar todos
        los riesgos vinculados al uso de cualquier Material, incluso como
        consecuencia de haberse basado en la exactitud e integridad del
        Material.
      </p>
      <p>
        EDENRED ARGENTINA no tiene el control de dicho Material y por lo tanto
        no garantiza la exactitud, integridad o calidad de éste. EDENRED
        ARGENTINA no será responsable en modo alguno por el Material,
        incluyendo, sin que ello implique limitación, cualesquiera errores u
        omisiones en el Material o cualquier pérdida o daño de cualquier índole
        como resultado del uso de cualquier Material colocado, transmitido o de
        otro modo disponible en el Sitio.
      </p>
      <p>
        Toda vez que EDENRED ARGENTINA no analiza ni puede analizar toda
        comunicación o información colocada o transmitida por usted u otras
        personas al Sitio o a terceros y no tiene responsabilidad alguna
        respecto del contenido de estos mensajes, EDENRED ARGENTINA se reserva
        el derecho de suprimir, trasladar el Material o solicitar a Ud. que lo
        suprima o modifique.
      </p>
      <p>
        Usted acuerda utilizar el Sitio en forma adecuada y asimismo que, al
        utilizar el Sitio, se abstendrá de:
      </p>
      <ul>
        <li>
          <p>
            Cargar, distribuir o de otro modo publicar material calumnioso,
            difamatorio, obsceno, desagradable, pornográfico, abusivo, ilegal,
            amenazador o de otro modo censurable;
          </p>
        </li>
        <li>
          <p>
            Cargar o distribuir archivos que contengan virus, gusanos, archivos
            dañados o cualquier otro software o programa similar que pudiera
            dañar el funcionamiento de la computadora o propiedad de otra
            persona;
          </p>
        </li>
        <li>
          <p>
            Hostigar, acosar, amenazar o de otro modo violar los derechos
            legales (incluyendo el derecho a la privacidad y el derecho a la
            publicidad) de terceros;
          </p>
        </li>
        <li>
          <p>
            Transmitir o de otro modo poner a disposición cualquier Material
            sobre el cual usted no tuviera derecho;
          </p>
        </li>
        <li>
          <p>
            Colocar material que viole los derechos de propiedad intelectual de
            terceros (incluyendo, sin limitación alguna, derechos de autor,
            secretos comerciales, marcas o demás derechos de propiedad
            exclusiva);
          </p>
        </li>
        <li>
          <p>
            Violar, en forma intencionada o no, cualquier ley aplicable de
            carácter local, provincial, nacional o internacional;
          </p>
        </li>
        <li>
          <p>
            Transmitir o de otro modo poner a disposición propagandas, material
            publicitario no pedido ni autorizado o cualquier otra forma de
            captación; y
          </p>
        </li>
        <li>
          <p>
            Distribuir o de otro modo publicar cualquier material que contenga
            captación de fondos, publicidad o bienes o servicios.
          </p>
        </li>
      </ul>
      <p>
        Usted reconoce y acuerda que EDENRED ARGENTINA podrá divulgar cualquier
        Material, y la fuente o propietario de cualquier Material, si ello le
        fuera requerido por una disposición o procedimiento legal, a fin de
        hacer cumplir las disposiciones de los presentes Términos o proteger los
        derechos de EDENRED ARGENTINA, sus clientes y/o Visitantes del Sitio.
      </p>
      <p>Derechos de EDENRED ARGENTINA sobre el Material Enviado al Sitio</p>
      <p>
        A menos que Usted indique lo contrario, cualquier Material que usted
        transmita o ponga de otro modo a disposición de este Sitio deberá
        adecuarse a estos Términos y no reviste el carácter de confidencial o de
        propiedad exclusiva. Automáticamente usted reconoce o garantiza, que Ud.
        y/o el propietario del Material ha otorgado a EDENRED ARGENTINA el
        derecho a usar, reproducir, publicar y crear obras derivadas de dicho
        Material, exhibir, distribuir, importar y transmitir dicho Material en
        cualquier forma, medios o tecnología, conocidos en la actualidad o
        desarrollados en el futuro, así como publicar el nombre de su
        propietario en relación con ello.
      </p>
      <p>
        EDENRED ARGENTINA da y dará cumplimiento a los presente términos en
        consonancia con la normativa argentina vigente.
      </p>
      <p>
        La última modificación de estos Términos tuvo lugar el 30 de abril de
        2020, y los mismos regirán su acceso a este Sitio desde dicha fecha y
        hasta tanto se incluya una modificación posterior.
      </p>
    </span>
  );
};
